import * as importedSdk from 'sharetribe-flex-sdk';

let exportSdk;

const isServer = () => typeof window === 'undefined';

if (isServer()) {
  // Only resolve at runtime on server; webpackIgnore prevents bundling in client build
  exportSdk = require(/* webpackIgnore: true */ 'sharetribe-flex-sdk');
} else {
  exportSdk = importedSdk;
}

const { createInstance, types, transit, util, file } = exportSdk;

// create image variant from variant name, desired width and aspectRatio.
// Optional options.fit (default 'crop') and options.crop (e.g. 'faces,top').
const createImageVariantConfig = (name, width, aspectRatio, options = {}) => {
  let variantWidth = width;
  let variantHeight = Math.round(aspectRatio * width);
  const fit = options.fit || 'crop';

  if (variantWidth > 3072 || variantHeight > 3072) {
    if (!isServer) {
      console.error(`Dimensions of custom image variant (${name}) are too high (w:${variantWidth}, h:${variantHeight}).
      Reduce them to max 3072px. https://www.sharetribe.com/api-reference/marketplace.html#custom-image-variants`);
    }

    if (variantHeight > 3072) {
      variantHeight = 3072;
      variantWidth = Math.round(variantHeight / aspectRatio);
    } else if (variantHeight > 3072) {
      variantWidth = 3072;
      variantHeight = Math.round(aspectRatio * variantWidth);
    }
  }

  return {
    [`imageVariant.${name}`]: util.objectQueryString({
      w: variantWidth,
      h: variantHeight,
      fit,
      ...(options.crop ? { crop: options.crop } : {}),
    }),
  };
};

export { createInstance, types, transit, util, file, createImageVariantConfig };
